import { ThemedView, ThemedText } from "@app/theme"

export const Card = ({ customerDetails }: { customerDetails: any }) => {

    const Divider = () => {
        return (
            <ThemedView height={2} backgroundColor='bg-fill-info'></ThemedView>
        )
    }

    return (
        <>
            <ThemedView style={{ backgroundColor: '#FFF', borderWidth: 1, borderColor: '#F1F3F5', borderRadius: 6, paddingHorizontal: 12, paddingVertical: 16 }}>
                <ThemedView style={{ flexDirection: 'row' }}>
                    <ThemedView style={{ width: 150 }}>
                        <ThemedText
                            variant="b3r"
                            color="text-secondary"
                        >
                            {`Applicant name`}
                        </ThemedText>
                    </ThemedView>
                    <ThemedText
                        variant="b3s"
                        color="text-primary"
                        fontWeight="400"
                    >
                        {`${customerDetails?.name ? customerDetails?.name : ''}`}
                    </ThemedText>
                </ThemedView>
                <ThemedView style={{ marginVertical: 16 }}>
                    <Divider />
                </ThemedView>
                <ThemedView style={{ flexDirection: 'row' }}>
                    <ThemedView style={{ width: 150 }}>
                        <ThemedText
                            variant="b3r"
                            color="text-secondary"
                        >
                            {`Mobile number`}
                        </ThemedText>
                    </ThemedView>
                    <ThemedText
                        variant="b3s"
                        color="text-primary"
                        fontWeight="400"
                    >
                        {`${customerDetails?.maskedPhone ? customerDetails?.maskedPhone : ''}`}
                    </ThemedText>
                </ThemedView>
                <ThemedView style={{ marginVertical: 16 }}>
                    <Divider />
                </ThemedView>
                {

                    customerDetails?.platform &&
                    <>
                        <ThemedView style={{
                            flexDirection: 'row'
                        }}>
                            <ThemedView style={{ width: 150 }}>
                                <ThemedText
                                    variant="b3r"
                                    color="text-secondary"
                                >
                                    {`Platform name`}
                                </ThemedText>

                            </ThemedView>

                            <ThemedText
                                variant="b3r"
                                color="text-primary"
                                fontWeight="400"
                            >
                                {`${customerDetails?.platform}`}
                            </ThemedText>
                        </ThemedView>
                        <ThemedView style={{ marginVertical: 16 }}>
                            <Divider />
                        </ThemedView>
                    </>
                }
                <ThemedView style={{ flexDirection: 'row' }}>
                    <ThemedView style={{ width: 150 }}>
                        <ThemedText
                            variant="b3r"
                            color="text-secondary"
                        >
                            {`Lender`}
                        </ThemedText>

                    </ThemedView>
                    <ThemedText
                        variant="b3r"
                        color="text-primary"
                        fontWeight="400"
                    >
                        {`${customerDetails?.lender ? customerDetails?.lender : ''}`}
                    </ThemedText>
                </ThemedView>
            </ThemedView>
        </>
    )
}   